module.exports = __webpack_public_path__ + "static/media/iStock-699871490.5971fea5.jpg";